import { SET_APPOINTMENT_FIELD,TOGGLE_APPOINTMENT_FIELD} from 'jsTheme/Actions/Appointments.action';
import {customFormatDate} from '../Core/date';
import {lang} from '../Core/lang';
const txtLang = lang.txt;

const webStyle = window.__appointment.preloadState.shop ?  window.__appointment.preloadState.shop.webStyle : 'STEP_VIEW';

const defaultState = {
	selectedProducts: [],
	selectedEmployees: webStyle === 'STEP_VIEW' ? '' : '00000000-0000-0000-0000-000000000000',
	selectedTimeline: {
		from: null,
		to: null
	},
	selectedCalendar: customFormatDate(new Date()),
  	fromDate: null,
	toDate: null,
	bookerInfo: {
		customerName: '',
		fullName: '',
		phoneNumber: '',
		email: '',
		birthDate: '',
		message: '',
		requestDate: '',
		sex: '女性',
		age: '',
		requestTime: '',
		advSelect: '',
		advFriend: '',
		minTimeOnWeek: '', 
		maxTimeOnWeek: '',
		minTimeWeekend: '',
		maxTimeWeekend: '',
		selectAge: '',
		listShops: '',
		listRequestItems: '',
		listOrders: '',
		listSize : '', 
		emailSubscribe: txtLang.subscribe_yes,
	},
	statusSubmit: '',
	validateAppointment: false
};
export const appointments = (state = defaultState, action) => {
	const {type, payload} = action;
	if (!payload) return state;
	let {listValue} = payload;
	switch (type) {
		case SET_APPOINTMENT_FIELD:
			let newState = {...state};
			listValue.forEach(e => {
				newState = {
					...newState,
					[e.key] : e.value
				}
			})
			return {
				...newState
			}
		case TOGGLE_APPOINTMENT_FIELD :
			let  {key, value} = payload.listValue;
			const arr = state[key];
			if (!Array.isArray(arr)) return state;
			const index = arr.indexOf(value);
			const newArr = index<0 ? [...arr, value] : [...arr.slice(0,index), ...arr.slice(index+1)];
			return {
				...state,
				[key] : newArr
			}	
		default:
			return state;
	}
}
